import { render } from "./AnnouncementsIndex.vue?vue&type=template&id=0334baa8"
import script from "./AnnouncementsIndex.vue?vue&type=script&lang=js"
export * from "./AnnouncementsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__